"use client";

import HowItWorksHeroSection from "@/components/how-it-works/hero-section";
import HowItWorksStepsSection from "@/components/how-it-works/steps-section";
import BrandsSection from "@/components/shared/brands-section";
import CTABannerSection from "@/components/shared/cta-banner-section";
import FAQSection from "@/components/shared/faq-section";
import TestimonialsSection from "@/components/shared/testimonials-section";

export default function HowItWorksPageView() {
  return (
    <>
      <HowItWorksHeroSection />
      <HowItWorksStepsSection />
      <BrandsSection />
      <TestimonialsSection />
      <FAQSection />
      <CTABannerSection />
    </>
  );
}
